
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as index3Pb2fdo6rThON46xs4sbAk0NuIzutnMXRqnreYfcdFsMeta } from "/builds/rialtic/qa/argocd-releases/console-ui/apps/console/pages/index.vue?macro=true";
import { default as influencing_45claimsDn3i9nNLNMZqIaMzl4W0J1jvK2IEFj1j5MngySSM8zIMeta } from "/builds/rialtic/qa/argocd-releases/console-ui/apps/console/pages/claims/[id]/[insightId]/influencing-claims.vue?macro=true";
import { default as _91id_93VfPzGqyJxsFKZ2_45aDDcCdWvxbsWuwyqjTU1SIgw9HkQMeta } from "/builds/rialtic/qa/argocd-releases/console-ui/apps/console/pages/claims/[id].vue?macro=true";
import { default as claimsgpJs_45rjtA0wOC_45KLPdPASzb_45wW0PfMipz37hN_454ZBJEMeta } from "/builds/rialtic/qa/argocd-releases/console-ui/apps/console/pages/claims.vue?macro=true";
import { default as welcomeDAjImvrPe1Qyk8zgX5ICnhb0hfkQKJNmYOtRtw4e7wwMeta } from "/builds/rialtic/qa/argocd-releases/console-ui/apps/console/pages/welcome.vue?macro=true";
import { default as edit_45modes8IcCg_45237zVa2wqfFtYIrQRRp1_NJSO6zsV8aqy08z8Meta } from "/builds/rialtic/qa/argocd-releases/console-ui/apps/console/pages/policies/[id]/edit-modes.vue?macro=true";
import { default as configurationidA9Wxy3AyfKVyDaEoOGrf9iHZ8EOhkPO0oRIam8UOoMeta } from "/builds/rialtic/qa/argocd-releases/console-ui/apps/console/pages/policies/[id]/configuration.vue?macro=true";
import { default as providers_45impacted47FbHeWMNPl2DL_dWQ_6_45exGqe_458ReFt5oJAxQzwOScMeta } from "/builds/rialtic/qa/argocd-releases/console-ui/apps/console/pages/policies/[id]/providers-impacted.vue?macro=true";
import { default as _91id_93zvyhOk2QV8MOnB_cnYf4LjmOvPqvySfWTndPjK1gHZUMeta } from "/builds/rialtic/qa/argocd-releases/console-ui/apps/console/pages/policies/[id].vue?macro=true";
import { default as indexZQtgmHIZrQlEIxlITiWacuWCb4G3fqKgOcu9tiKBqYIMeta } from "/builds/rialtic/qa/argocd-releases/console-ui/apps/console/pages/policies/index.vue?macro=true";
import { default as policiesrJHjMJKdpsK3N_Bb_45NmFYb4s7en5lfEdadwcLEwY2w4Meta } from "/builds/rialtic/qa/argocd-releases/console-ui/apps/console/pages/policies.vue?macro=true";
import { default as changelogqeM0N_w1AK91hhGWnCWYdiKO2bFvsCK4Ff4X1lV2GtAMeta } from "/builds/rialtic/qa/argocd-releases/console-ui/apps/console/pages/changelog.vue?macro=true";
import { default as providersyZEEe9PMyglcvsZka1zUgONBaUrVtFu8v8wPJN5hv4AMeta } from "/builds/rialtic/qa/argocd-releases/console-ui/apps/console/pages/providers.vue?macro=true";
import { default as app_45statusdRGVvmgymVmhiYiGI91eLa6Pc_45k9KrbSYI5fNudWCzoMeta } from "/builds/rialtic/qa/argocd-releases/console-ui/apps/console/pages/app-status.vue?macro=true";
import { default as index9prLK_3FZ72Fr7eAoqvLHYnalzIq4hVhqqeX5qGXSnUMeta } from "/builds/rialtic/qa/argocd-releases/console-ui/apps/console/pages/exclusions/index.vue?macro=true";
import { default as create2lOPaArUpqs_u4EewAiDwTgp1ne8P5BPszrSC6DnR9cMeta } from "/builds/rialtic/qa/argocd-releases/console-ui/apps/console/pages/exclusions/create.vue?macro=true";
import { default as edit3NEWb24_Du3MsSMc7dVtISyxgGL_tFD8ePFWM8iamPkMeta } from "/builds/rialtic/qa/argocd-releases/console-ui/apps/console/pages/exclusions/[id]/edit.vue?macro=true";
import { default as index5vg4qKwfJ_45a3d1n_4510dRw7hxzuI9y9bXb7h7RA23PKEMeta } from "/builds/rialtic/qa/argocd-releases/console-ui/apps/console/pages/exclusions/[id]/index.vue?macro=true";
import { default as exclusionsoldnoriJkjp4FXFWgI_45SPpWXolGaFtGm_pe2bp4UlYAMeta } from "/builds/rialtic/qa/argocd-releases/console-ui/apps/console/pages/exclusions.vue?macro=true";
import { default as create_45workspaceTCcfy2UwTA4mtE3YReq32wz9torpb2KhkeOC7YcMWoYMeta } from "/builds/rialtic/qa/argocd-releases/console-ui/apps/console/pages/admin/index/create-workspace.vue?macro=true";
import { default as indexOLeJdZmXgjgH6NCVA8dpuwX1iy_viOBolVt3BsKYSgIMeta } from "/builds/rialtic/qa/argocd-releases/console-ui/apps/console/pages/admin/index.vue?macro=true";
import { default as users6OQXo7FCGnJAFnjABxrhjCjf8E9K6jAW5dbKfhQkbs0Meta } from "/builds/rialtic/qa/argocd-releases/console-ui/apps/console/pages/admin/users.vue?macro=true";
import { default as maintenancebEapbml_45GsretMsL0MK4gNDrdOeYInPNgcr2UfgOmmAMeta } from "/builds/rialtic/qa/argocd-releases/console-ui/apps/console/pages/maintenance.vue?macro=true";
import { default as indexu_V186g1I_6TQ8gsYM00AKW1NNRfmW3Ozzthx6GOr2gMeta } from "/builds/rialtic/qa/argocd-releases/console-ui/apps/console/pages/[connectorId]/claim-lab/index.vue?macro=true";
import { default as _91rid_93spi0KXyc4dTwh2M2_v49xtA9PcEddYmlJrXObJl2OGoMeta } from "/builds/rialtic/qa/argocd-releases/console-ui/apps/claim-lab/pages/[connectorId]/claim-lab/[claimId]/[rid].vue?macro=true";
import { default as _91connectorId_93GTdSlJj_45mR8fp8JiykxUD473kgwb0S_GnjY5M0_ZvhQMeta } from "/builds/rialtic/qa/argocd-releases/console-ui/apps/claim-lab/pages/[connectorId].vue?macro=true";
import { default as indexTPg2avXfQRjT4HstOGRB2dmK_45p_45bjBh9Ofc_45LovioLsMeta } from "/builds/rialtic/qa/argocd-releases/console-ui/apps/console/pages/account/index.vue?macro=true";
import { default as usersoLAuUDiL8RF0Erav1md0ffHhyeLns_45wkhn1d91j4vlwMeta } from "/builds/rialtic/qa/argocd-releases/console-ui/apps/console/pages/account/users.vue?macro=true";
import { default as api_45adminr7XsuYfG1b8_45_Bwn3xqO7mmsrVWiy1u8Ym5i3dyo7QsMeta } from "/builds/rialtic/qa/argocd-releases/console-ui/apps/console/pages/admin/api-admin.vue?macro=true";
import { default as indexhLq8kLxqdMg4iA_45tcnR44VuGtqr0P8YOZNKkUhavttUMeta } from "/builds/rialtic/qa/argocd-releases/console-ui/apps/console/pages/dashboard/index.vue?macro=true";
import { default as app_45configlQ_45iCxZMO42zxVMe4poR6fFM49dLUaSFPXROlppLkpkMeta } from "/builds/rialtic/qa/argocd-releases/console-ui/apps/console/pages/admin/app-config.vue?macro=true";
import { default as _91id_936fuPTKjN5_457jY8DFEXy071kry3L_45DttiQwRSgJaIr7AMeta } from "/builds/rialtic/qa/argocd-releases/console-ui/apps/console/pages/dashboard/policies/[id].vue?macro=true";
import { default as policiesoBTHvvXamJI3AAsdsWUdwy7KFQlNEIKdWaryTHVz6GEMeta } from "/builds/rialtic/qa/argocd-releases/console-ui/apps/console/pages/dashboard/policies.vue?macro=true";
import { default as api_45clientsJe_e__45G0Pzkp68_WKyMej5ll1ADfkAwo5M15UVtZCAAMeta } from "/builds/rialtic/qa/argocd-releases/console-ui/apps/console/pages/account/api-clients.vue?macro=true";
import { default as providersvnghB_7JLcN65GPdIDI2rz5TI2T2WvO6827KFOvIeqcMeta } from "/builds/rialtic/qa/argocd-releases/console-ui/apps/console/pages/dashboard/providers.vue?macro=true";
import { default as edit05d5lJ2qvp09YJ6uICXDUVD0Od3keFhRCvdtbAiYufgMeta } from "/builds/rialtic/qa/argocd-releases/console-ui/apps/console/pages/admin/workspace/[id]/index/edit.vue?macro=true";
import { default as indexXdhT5zOmw2USEwbDd8Ct_DEDhqX0WZrxkqHDW2BFdjcMeta } from "/builds/rialtic/qa/argocd-releases/console-ui/apps/console/pages/admin/workspace/[id]/index/connector/index.vue?macro=true";
import { default as _91connId_93BmHELJ_xnd0wMl7EVVC_Pq1w_45CHVCX1qKd_Q7iIAnK8Meta } from "/builds/rialtic/qa/argocd-releases/console-ui/apps/console/pages/admin/workspace/[id]/index/connector/[connId].vue?macro=true";
import { default as indexNE1O472jr3_45zmBoFNiz_WL06sCRTTR9vWUQ3OUsN0jQMeta } from "/builds/rialtic/qa/argocd-releases/console-ui/apps/console/pages/admin/workspace/[id]/index.vue?macro=true";
import { default as _91id_93yoYj3UEA2gsBFgf0C6hsP9JDl7o3tLav2N0mhatBx5kMeta } from "/builds/rialtic/qa/argocd-releases/console-ui/apps/console/pages/admin/workspace/[id].vue?macro=true";
import { default as indexST1vsBE6JsLZ0VulflMzCxPKABUWkeeZCAcEMsIcYKkMeta } from "/builds/rialtic/qa/argocd-releases/console-ui/apps/console/pages/dashboard/exclusions/[id]/index.vue?macro=true";
import { default as exclusionshhJ788Bhf01x2PETb66eiwg5tQ7h_KHqO_KKQ0u6qioMeta } from "/builds/rialtic/qa/argocd-releases/console-ui/apps/console/pages/dashboard/exclusions.vue?macro=true";
import { default as indexp0mA3V3YHpkQfpPpsq_45huEdmxDNdzWVnt33C25REB4AMeta } from "/builds/rialtic/qa/argocd-releases/console-ui/apps/console/pages/admin/workspace/index.vue?macro=true";
import { default as claim_45searcheV35VgNy4o7Nv9nbd_w0ZWaaGP_45zrDcpT4nD_BJHzxYMeta } from "/builds/rialtic/qa/argocd-releases/console-ui/apps/console/pages/dashboard/claim-search.vue?macro=true";
import { default as legalGZZT5QAqm3jKQu9_45zDokRi_45G_xcJqujxznq0lbPacBQMeta } from "/builds/rialtic/qa/argocd-releases/console-ui/modules/nuxt-auth0/src/runtime/pages/legal.vue?macro=true";
import { default as auth_45callbackUwMieFzDqMujkUvHOq5hM1Cf_5N3poyE5snk8fojFWYMeta } from "/builds/rialtic/qa/argocd-releases/console-ui/modules/nuxt-auth0/src/runtime/pages/auth-callback.vue?macro=true";
import { default as auth_45logineB7XzR7hQ_DIyvy_HK2zNPZOQgUdz_458aA5jwNwTFzLwMeta } from "/builds/rialtic/qa/argocd-releases/console-ui/modules/nuxt-auth0/src/runtime/pages/auth-login.vue?macro=true";
import { default as auth_45status5CN_T2cGhj77ZWqxAre2Gj7SUMY56vIWix7C_45LowKhcMeta } from "/builds/rialtic/qa/argocd-releases/console-ui/modules/nuxt-auth0/src/runtime/pages/auth-status.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    meta: { ...(index3Pb2fdo6rThON46xs4sbAk0NuIzutnMXRqnreYfcdFsMeta || {}), ...{"middleware":"connector-required"} },
    component: () => import("/builds/rialtic/qa/argocd-releases/console-ui/apps/console/pages/index.vue")
  },
  {
    name: "claims",
    path: "/claims",
    meta: { ...(claimsgpJs_45rjtA0wOC_45KLPdPASzb_45wW0PfMipz37hN_454ZBJEMeta || {}), ...{"middleware":["connector-required"]} },
    component: () => import("/builds/rialtic/qa/argocd-releases/console-ui/apps/console/pages/claims.vue"),
    children: [
  {
    name: "claims-id",
    path: ":id()",
    meta: { ...(_91id_93VfPzGqyJxsFKZ2_45aDDcCdWvxbsWuwyqjTU1SIgw9HkQMeta || {}), ...{"middleware":"connector-required"} },
    component: () => import("/builds/rialtic/qa/argocd-releases/console-ui/apps/console/pages/claims/[id].vue"),
    children: [
  {
    name: "claims-id-insightId-influencing-claims",
    path: ":insightId()/influencing-claims",
    meta: { ...(influencing_45claimsDn3i9nNLNMZqIaMzl4W0J1jvK2IEFj1j5MngySSM8zIMeta || {}), ...{"middleware":"connector-required"} },
    component: () => import("/builds/rialtic/qa/argocd-releases/console-ui/apps/console/pages/claims/[id]/[insightId]/influencing-claims.vue")
  }
]
  }
]
  },
  {
    name: "welcome",
    path: "/welcome",
    meta: welcomeDAjImvrPe1Qyk8zgX5ICnhb0hfkQKJNmYOtRtw4e7wwMeta || {},
    component: () => import("/builds/rialtic/qa/argocd-releases/console-ui/apps/console/pages/welcome.vue")
  },
  {
    name: policiesrJHjMJKdpsK3N_Bb_45NmFYb4s7en5lfEdadwcLEwY2w4Meta?.name,
    path: "/policies",
    meta: policiesrJHjMJKdpsK3N_Bb_45NmFYb4s7en5lfEdadwcLEwY2w4Meta || {},
    component: () => import("/builds/rialtic/qa/argocd-releases/console-ui/apps/console/pages/policies.vue"),
    children: [
  {
    name: "policies-id",
    path: ":id()",
    meta: { ...(_91id_93zvyhOk2QV8MOnB_cnYf4LjmOvPqvySfWTndPjK1gHZUMeta || {}), ...{"middleware":["connector-required"]} },
    component: () => import("/builds/rialtic/qa/argocd-releases/console-ui/apps/console/pages/policies/[id].vue"),
    children: [
  {
    name: "policies-id-edit-modes",
    path: "edit-modes",
    meta: { ...(edit_45modes8IcCg_45237zVa2wqfFtYIrQRRp1_NJSO6zsV8aqy08z8Meta || {}), ...{"middleware":["connector-required","policy-context-required"]} },
    component: () => import("/builds/rialtic/qa/argocd-releases/console-ui/apps/console/pages/policies/[id]/edit-modes.vue")
  },
  {
    name: "policies-id-configuration",
    path: "configuration",
    meta: { ...(configurationidA9Wxy3AyfKVyDaEoOGrf9iHZ8EOhkPO0oRIam8UOoMeta || {}), ...{"middleware":"connector-required"} },
    component: () => import("/builds/rialtic/qa/argocd-releases/console-ui/apps/console/pages/policies/[id]/configuration.vue")
  },
  {
    name: "policies-id-providers-impacted",
    path: "providers-impacted",
    meta: { ...(providers_45impacted47FbHeWMNPl2DL_dWQ_6_45exGqe_458ReFt5oJAxQzwOScMeta || {}), ...{"middleware":"connector-required"} },
    component: () => import("/builds/rialtic/qa/argocd-releases/console-ui/apps/console/pages/policies/[id]/providers-impacted.vue")
  }
]
  },
  {
    name: "policies",
    path: "",
    component: () => import("/builds/rialtic/qa/argocd-releases/console-ui/apps/console/pages/policies/index.vue")
  }
]
  },
  {
    name: "changelog",
    path: "/changelog",
    meta: { ...(changelogqeM0N_w1AK91hhGWnCWYdiKO2bFvsCK4Ff4X1lV2GtAMeta || {}), ...{"middleware":["connector-required"]} },
    component: () => import("/builds/rialtic/qa/argocd-releases/console-ui/apps/console/pages/changelog.vue")
  },
  {
    name: "providers",
    path: "/providers",
    meta: { ...(providersyZEEe9PMyglcvsZka1zUgONBaUrVtFu8v8wPJN5hv4AMeta || {}), ...{"middleware":"connector-required"} },
    component: () => import("/builds/rialtic/qa/argocd-releases/console-ui/apps/console/pages/providers.vue")
  },
  {
    name: "app-status",
    path: "/app-status",
    meta: app_45statusdRGVvmgymVmhiYiGI91eLa6Pc_45k9KrbSYI5fNudWCzoMeta || {},
    component: () => import("/builds/rialtic/qa/argocd-releases/console-ui/apps/console/pages/app-status.vue")
  },
  {
    name: exclusionsoldnoriJkjp4FXFWgI_45SPpWXolGaFtGm_pe2bp4UlYAMeta?.name,
    path: "/exclusions",
    meta: { ...(exclusionsoldnoriJkjp4FXFWgI_45SPpWXolGaFtGm_pe2bp4UlYAMeta || {}), ...{"middleware":"connector-required"} },
    component: () => import("/builds/rialtic/qa/argocd-releases/console-ui/apps/console/pages/exclusions.vue"),
    children: [
  {
    name: "exclusions",
    path: "",
    component: () => import("/builds/rialtic/qa/argocd-releases/console-ui/apps/console/pages/exclusions/index.vue")
  },
  {
    name: "exclusions-create",
    path: "create",
    meta: create2lOPaArUpqs_u4EewAiDwTgp1ne8P5BPszrSC6DnR9cMeta || {},
    component: () => import("/builds/rialtic/qa/argocd-releases/console-ui/apps/console/pages/exclusions/create.vue")
  },
  {
    name: "exclusions-id-edit",
    path: ":id()/edit",
    meta: edit3NEWb24_Du3MsSMc7dVtISyxgGL_tFD8ePFWM8iamPkMeta || {},
    component: () => import("/builds/rialtic/qa/argocd-releases/console-ui/apps/console/pages/exclusions/[id]/edit.vue")
  },
  {
    name: "exclusions-id",
    path: ":id()",
    meta: { ...(index5vg4qKwfJ_45a3d1n_4510dRw7hxzuI9y9bXb7h7RA23PKEMeta || {}), ...{"middleware":"connector-required"} },
    component: () => import("/builds/rialtic/qa/argocd-releases/console-ui/apps/console/pages/exclusions/[id]/index.vue")
  }
]
  },
  {
    name: "admin",
    path: "/admin",
    meta: { ...(indexOLeJdZmXgjgH6NCVA8dpuwX1iy_viOBolVt3BsKYSgIMeta || {}), ...{"middleware":"rialtic-admin"} },
    component: () => import("/builds/rialtic/qa/argocd-releases/console-ui/apps/console/pages/admin/index.vue"),
    children: [
  {
    name: "admin-index-create-workspace",
    path: "create-workspace",
    meta: { ...(create_45workspaceTCcfy2UwTA4mtE3YReq32wz9torpb2KhkeOC7YcMWoYMeta || {}), ...{"middleware":"rialtic-admin"} },
    component: () => import("/builds/rialtic/qa/argocd-releases/console-ui/apps/console/pages/admin/index/create-workspace.vue")
  }
]
  },
  {
    name: "admin-users",
    path: "/admin/users",
    meta: { ...(users6OQXo7FCGnJAFnjABxrhjCjf8E9K6jAW5dbKfhQkbs0Meta || {}), ...{"middleware":"rialtic-admin"} },
    component: () => import("/builds/rialtic/qa/argocd-releases/console-ui/apps/console/pages/admin/users.vue")
  },
  {
    name: "maintenance",
    path: "/maintenance",
    meta: maintenancebEapbml_45GsretMsL0MK4gNDrdOeYInPNgcr2UfgOmmAMeta || {},
    component: () => import("/builds/rialtic/qa/argocd-releases/console-ui/apps/console/pages/maintenance.vue")
  },
  {
    name: "connectorId",
    path: "/:connectorId()",
    component: () => import("/builds/rialtic/qa/argocd-releases/console-ui/apps/claim-lab/pages/[connectorId].vue"),
    children: [
  {
    name: "connectorId-claim-lab",
    path: "claim-lab",
    component: () => import("/builds/rialtic/qa/argocd-releases/console-ui/apps/console/pages/[connectorId]/claim-lab/index.vue")
  },
  {
    name: "connectorId-claim-lab-claimId-rid",
    path: "claim-lab/:claimId()/:rid()",
    meta: { ...(_91rid_93spi0KXyc4dTwh2M2_v49xtA9PcEddYmlJrXObJl2OGoMeta || {}), ...{"middleware":["claim-lab"]} },
    component: () => import("/builds/rialtic/qa/argocd-releases/console-ui/apps/claim-lab/pages/[connectorId]/claim-lab/[claimId]/[rid].vue")
  }
]
  },
  {
    name: "account",
    path: "/account",
    meta: indexTPg2avXfQRjT4HstOGRB2dmK_45p_45bjBh9Ofc_45LovioLsMeta || {},
    component: () => import("/builds/rialtic/qa/argocd-releases/console-ui/apps/console/pages/account/index.vue")
  },
  {
    name: "account-users",
    path: "/account/users",
    meta: usersoLAuUDiL8RF0Erav1md0ffHhyeLns_45wkhn1d91j4vlwMeta || {},
    component: () => import("/builds/rialtic/qa/argocd-releases/console-ui/apps/console/pages/account/users.vue")
  },
  {
    name: "admin-api-admin",
    path: "/admin/api-admin",
    meta: { ...(api_45adminr7XsuYfG1b8_45_Bwn3xqO7mmsrVWiy1u8Ym5i3dyo7QsMeta || {}), ...{"middleware":"rialtic-admin"} },
    component: () => import("/builds/rialtic/qa/argocd-releases/console-ui/apps/console/pages/admin/api-admin.vue")
  },
  {
    name: "dashboard",
    path: "/dashboard",
    meta: { ...(indexhLq8kLxqdMg4iA_45tcnR44VuGtqr0P8YOZNKkUhavttUMeta || {}), ...{"middleware":"all-connectors"} },
    component: () => import("/builds/rialtic/qa/argocd-releases/console-ui/apps/console/pages/dashboard/index.vue")
  },
  {
    name: "admin-app-config",
    path: "/admin/app-config",
    meta: { ...(app_45configlQ_45iCxZMO42zxVMe4poR6fFM49dLUaSFPXROlppLkpkMeta || {}), ...{"middleware":"rialtic-admin"} },
    component: () => import("/builds/rialtic/qa/argocd-releases/console-ui/apps/console/pages/admin/app-config.vue")
  },
  {
    name: "dashboard-policies",
    path: "/dashboard/policies",
    meta: { ...(policiesoBTHvvXamJI3AAsdsWUdwy7KFQlNEIKdWaryTHVz6GEMeta || {}), ...{"middleware":"all-connectors"} },
    component: () => import("/builds/rialtic/qa/argocd-releases/console-ui/apps/console/pages/dashboard/policies.vue"),
    children: [
  {
    name: "dashboard-policies-id",
    path: ":id()",
    meta: { ...(_91id_936fuPTKjN5_457jY8DFEXy071kry3L_45DttiQwRSgJaIr7AMeta || {}), ...{"middleware":"all-connectors"} },
    component: () => import("/builds/rialtic/qa/argocd-releases/console-ui/apps/console/pages/dashboard/policies/[id].vue")
  }
]
  },
  {
    name: "account-api-clients",
    path: "/account/api-clients",
    meta: { ...(api_45clientsJe_e__45G0Pzkp68_WKyMej5ll1ADfkAwo5M15UVtZCAAMeta || {}), ...{"middleware":["workspace-system-admin"]} },
    component: () => import("/builds/rialtic/qa/argocd-releases/console-ui/apps/console/pages/account/api-clients.vue")
  },
  {
    name: "dashboard-providers",
    path: "/dashboard/providers",
    meta: { ...(providersvnghB_7JLcN65GPdIDI2rz5TI2T2WvO6827KFOvIeqcMeta || {}), ...{"middleware":"all-connectors"} },
    component: () => import("/builds/rialtic/qa/argocd-releases/console-ui/apps/console/pages/dashboard/providers.vue")
  },
  {
    name: _91id_93yoYj3UEA2gsBFgf0C6hsP9JDl7o3tLav2N0mhatBx5kMeta?.name,
    path: "/admin/workspace/:id()",
    meta: { ...(_91id_93yoYj3UEA2gsBFgf0C6hsP9JDl7o3tLav2N0mhatBx5kMeta || {}), ...{"middleware":"rialtic-admin"} },
    component: () => import("/builds/rialtic/qa/argocd-releases/console-ui/apps/console/pages/admin/workspace/[id].vue"),
    children: [
  {
    name: "admin-workspace-id",
    path: "",
    component: () => import("/builds/rialtic/qa/argocd-releases/console-ui/apps/console/pages/admin/workspace/[id]/index.vue"),
    children: [
  {
    name: "admin-workspace-id-index-edit",
    path: "edit",
    component: () => import("/builds/rialtic/qa/argocd-releases/console-ui/apps/console/pages/admin/workspace/[id]/index/edit.vue")
  },
  {
    name: "admin-workspace-id-index-connector",
    path: "connector",
    component: () => import("/builds/rialtic/qa/argocd-releases/console-ui/apps/console/pages/admin/workspace/[id]/index/connector/index.vue")
  },
  {
    name: "admin-workspace-id-index-connector-connId",
    path: "connector/:connId()",
    component: () => import("/builds/rialtic/qa/argocd-releases/console-ui/apps/console/pages/admin/workspace/[id]/index/connector/[connId].vue")
  }
]
  }
]
  },
  {
    name: "dashboard-exclusions",
    path: "/dashboard/exclusions",
    meta: { ...(exclusionshhJ788Bhf01x2PETb66eiwg5tQ7h_KHqO_KKQ0u6qioMeta || {}), ...{"middleware":"all-connectors"} },
    component: () => import("/builds/rialtic/qa/argocd-releases/console-ui/apps/console/pages/dashboard/exclusions.vue"),
    children: [
  {
    name: "dashboard-exclusions-id",
    path: ":id()",
    meta: { ...(indexST1vsBE6JsLZ0VulflMzCxPKABUWkeeZCAcEMsIcYKkMeta || {}), ...{"middleware":"all-connectors"} },
    component: () => import("/builds/rialtic/qa/argocd-releases/console-ui/apps/console/pages/dashboard/exclusions/[id]/index.vue")
  }
]
  },
  {
    name: "admin-workspace",
    path: "/admin/workspace",
    meta: indexp0mA3V3YHpkQfpPpsq_45huEdmxDNdzWVnt33C25REB4AMeta || {},
    component: () => import("/builds/rialtic/qa/argocd-releases/console-ui/apps/console/pages/admin/workspace/index.vue")
  },
  {
    name: "dashboard-claim-search",
    path: "/dashboard/claim-search",
    meta: claim_45searcheV35VgNy4o7Nv9nbd_w0ZWaaGP_45zrDcpT4nD_BJHzxYMeta || {},
    component: () => import("/builds/rialtic/qa/argocd-releases/console-ui/apps/console/pages/dashboard/claim-search.vue")
  },
  {
    name: "legal-notice",
    path: "/legal/licensed-content-notice",
    meta: legalGZZT5QAqm3jKQu9_45zDokRi_45G_xcJqujxznq0lbPacBQMeta || {},
    component: () => import("/builds/rialtic/qa/argocd-releases/console-ui/modules/nuxt-auth0/src/runtime/pages/legal.vue")
  },
  {
    name: "auth-callback",
    path: "/auth/callback",
    meta: auth_45callbackUwMieFzDqMujkUvHOq5hM1Cf_5N3poyE5snk8fojFWYMeta || {},
    component: () => import("/builds/rialtic/qa/argocd-releases/console-ui/modules/nuxt-auth0/src/runtime/pages/auth-callback.vue")
  },
  {
    name: "auth-login",
    path: "/auth/login",
    meta: auth_45logineB7XzR7hQ_DIyvy_HK2zNPZOQgUdz_458aA5jwNwTFzLwMeta || {},
    component: () => import("/builds/rialtic/qa/argocd-releases/console-ui/modules/nuxt-auth0/src/runtime/pages/auth-login.vue")
  },
  {
    name: "auth-status",
    path: "/auth/status",
    meta: auth_45status5CN_T2cGhj77ZWqxAre2Gj7SUMY56vIWix7C_45LowKhcMeta || {},
    component: () => import("/builds/rialtic/qa/argocd-releases/console-ui/modules/nuxt-auth0/src/runtime/pages/auth-status.vue")
  }
]